<template>
    <div class="row" v-if="show_extra_consent">
        <div class="col-12">
            <div id="accordionOne">
                <div id="extraConsent" class="card">
                    <div class="card-header cursorPointer" @click="toggleAccordionSection()"
                         :id="`heading_terminal`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal`"
                         aria-expanded="true" :aria-controls="`collapse_terminal`">
                        <h5 class="mb-0">
                            <span v-if="extra_consent_block.is_open" class="caretSign rotate"><i
                                class="fa fa-caret-up"></i></span>
                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                            <template v-if="isOpenApplication">
                                <span><button @click=""
                                              class="btn btn-default">{{ lang('consent_and_submission') }}</button></span>
                            </template>
                            <template v-else>
                                <span>{{ lang('consent') }}</span>
                            </template>
                        </h5>
                    </div>
                    <div data-bs-parent="#accordionOne" id="collapse_terminal" :aria-labelledby="`heading_terminal`"
                         class="collapse card-body">
                        <div class="row">
                            <gdpr-block v-if="show_gdpr_block">
                            </gdpr-block>
                        </div>
                        <div class="row" v-if="show_consent_proprietorship_share">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall"><span
                                    style="white-space: normal;display: inline-block;"
                                    class="markedBottom">{{ lang('consent_proprietorship_share_data_header') }}</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-if="isOpenApplication">
                                <np-checkbox ref="consent_proprietorship_share_data"
                                             :id="'consent_proprietorship_share_data'"
                                             :name="'consent_proprietorship_share_data'"
                                             :description="lang('consent_proprietorship_share_data')"
                                             :has-html-description="true"
                                             :required="true"
                                             :value="'1'"
                                             :no-wrapper="true"
                                             @change="toggleConsentProprietorshipShareData($event)"
                                             v-model="quote.consent_proprietorship_share_data">
                                </np-checkbox>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-else>
                                <span slot="addendum" v-html="lang('consent_proprietorship_share_data')">
                                </span>
                            </div>
                        </div>
                        <div class="row" v-if="show_consent_bank_pci">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall"><span
                                    style="white-space: normal;display: inline-block;"
                                    class="markedBottom">{{ lang('consent_bank_pci_header') }}</span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-if="isOpenApplication">
                                <np-checkbox ref="consent_bank_pci"
                                             :id="'consent_bank_pci'"
                                             :name="'consent_bank_pci'"
                                             :description="lang('consent_bank_pci')"
                                             :required="true"
                                             :value="'1'"
                                             :no-wrapper="true"
                                             @change="toggleConsentBankPci($event)"
                                             v-model="quote.consent_bank_pci">
                                </np-checkbox>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-else>
                                <span slot="addendum">
                                    {{ lang('consent_bank_pci') }}
                                </span>
                            </div>
                        </div>
                        <div class="row" v-if="show_consent_opayo">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span style="white-space: normal;display: inline-block;"
                                          class="markedBottom">{{ lang('consent_opayo_header') }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-if="isOpenApplication">
                                <div class="row">
                                    <div class="col-auto">
                                        <np-checkbox
                                              ref="consent_opayo"
                                              :id="'consent_opayo'"
                                              :name="'consent_opayo'"
                                              :required="true"
                                              :value="'1'"
                                              :no-wrapper="true"
                                              :disabled="!this.is_consent_clicked"
                                              @change="toggleConsentOpayo($event)"
                                              v-model="quote.consent_opayo">
                                        </np-checkbox>
                                    </div>
                                    <div class="col-10" style="text-align: left;padding-left: 0; padding-top: 10px;">
                                        <span style="color: dodgerblue;text-decoration:underline;margin-left: 5px;cursor: pointer;"
                                              @click="openOpayoModel()">{{ lang('consent_opayo') }}
                                      </span>
                                    </div>
                                </div>
                                <span slot="addendum">
                                    {{ lang('consent_opayo_checkbox_desc') }}
                                </span>
                            </div>
                            <div class="col-lg-12 col-md-12 col-12" v-else>
                                <span slot="addendum">
                                    {{ lang('consent_opayo') }}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <np-pdf-modal url="/application/viewmerchantopayodocument/" :title="lang('consent_opayo_popup_header')"
                      id="opayo-modal"></np-pdf-modal>
    </div>
    <div v-else>
        <gdpr-block v-if="show_gdpr_block">
        </gdpr-block>
    </div>

</template>

<script>

import applicationMixin from "../../../utils/application-mixin";
import {mapState} from 'pinia';
import {NPCheckBox, NPPdfModal} from "netpify/components";
import utilMixin from "../../../utils/mixins";
import GdprBlock from './gdpr-block.vue';
import useApplicationStore from "../../../stores/application_module";

export default {
    name: "MerchantConsent",
    mixins: [applicationMixin, utilMixin],
    components: {
        'np-checkbox': NPCheckBox,
        'gdpr-block': GdprBlock,
        'np-pdf-modal': NPPdfModal
    },
    metaInfo() {
        return {
            title: this.lang('tab_review')
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
        })
    },
    props: {
        show_extra_consent_block: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        show_gdpr_block: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
    },
    data: function () {
        return {
            previous_extra_consent_opened_checked: false,
            is_consent_clicked:false,
            extra_consent_block: {
                is_open: false,
            },
        };
    },
    methods: {
        toggleAccordionSection: function () {
            this.extra_consent_block.is_open = !(this.extra_consent_block.is_open);
            this.triggerExtraConsentOpenAndCheckedEvent();
        },
        toggleConsentProprietorshipShareData: function () {
            this.triggerExtraConsentOpenAndCheckedEvent();
        },
        toggleConsentBankPci: function () {
            this.triggerExtraConsentOpenAndCheckedEvent();
        },
        toggleConsentOpayo: function () {
            this.triggerExtraConsentOpenAndCheckedEvent();
        },
        triggerExtraConsentOpenAndCheckedEvent: function () {
            let new_extra_consent_opened_checked = this.extra_consent_block.is_open && this.allMandatoryOptionsSelected();
            if (this.previous_extra_consent_opened_checked !== new_extra_consent_opened_checked) {
                this.previous_extra_consent_opened_checked = new_extra_consent_opened_checked;
                this.$emit('extra-consent-opened-checked', new_extra_consent_opened_checked);
            }
        },
        openOpayoModel: function () {
            this.is_consent_clicked = true;
            // $('#opayo-modal').modal();
            var myModalEl = document.querySelector('#opayo-modal')
            var modal = bootstrap.Modal.getOrCreateInstance(myModalEl) // Returns a Bootstrap modal instance
            modal.show()
        },
        allMandatoryOptionsSelected: function () {
            let all_mandatory_options = [];
            if (this.show_consent_proprietorship_share) {
                all_mandatory_options.push(this.quote.consent_proprietorship_share_data);
            }
            if (this.show_consent_bank_pci) {
                all_mandatory_options.push(this.quote.consent_bank_pci);
            }
            if (this.show_consent_opayo) {
                all_mandatory_options.push(this.quote.consent_opayo);
            }
            return all_mandatory_options.every(option => option === '1');
        },
    },
    computed: {
        ...mapState(useApplicationStore,{app_chain: 'application'}),
        show_extra_consent: function () {
            return this.$attrs['need_extra_consent_block'];
        },
        show_consent_proprietorship_share: function () {
            return this.alliance.contact_country === '616' && (this.isSoleTrader || this.isPartnership);
        },
        show_consent_bank_pci: function () {
            return this.alliance.contact_country === '616';
        },
        show_consent_opayo: function () {
            let has_opayo_consent_action = this.parameters.hasOwnProperty('APPLICATION_PROCESS_ACTION_FUNCTIONS_CHECK')
                && this.parameters.APPLICATION_PROCESS_ACTION_FUNCTIONS_CHECK.hasOwnProperty('OPAYO_CONSENT')
                && this.parameters.APPLICATION_PROCESS_ACTION_FUNCTIONS_CHECK.OPAYO_CONSENT === true;
            return has_opayo_consent_action;
        },
    },
    watch: {
        'quote' : {
            immediate: true,
            handler: function (val) {
                let vm = this
                //console.log('Quote Watch merchant Consent', vm.quote.consent_proprietorship_share_data, vm.quote.consent_bank_pci);
                //trigger in-case vm.quote.consent_proprietorship_share_data, vm.quote.consent_bank_pci has mutated
                vm.triggerExtraConsentOpenAndCheckedEvent();
            }
        },
    }
}
</script>
